
import TableList from "@components/templates/tablelist";
import { HttpGetSysWarehouseCarrier, HttpFailureSysWarehouse, HttpAllFailureSysWarehouse, HttpActiveSysWarehouse, HttpAllActiveSysWarehouse} from "@/service/managechannel/managechannel";
import { mapState } from "vuex";
import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            erpSkusList:[],
        };
    },
    methods: {
        ajaxRequest: HttpGetSysWarehouseCarrier,
        interceptRequest(params){
            params.country = params.search.country
            delete params.search.country
            // console.log(params)
            return params
        },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            // console.log(type,batch)
            if(type!='batchmanage'){
                if(batch){
                    // console.log(124234)
                    params=(params||this.checkedData.join(','))+'';
                    if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
                }
            }
            switch (type) {
                case "batchmanage":
                    this.$router.push({
                        name: 'sysWareBatchway',
                        params: { type: "batch" },
                        // query: { id: params },
                    });
                break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "sysWareUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "edit":
                    this.$router.push({
                        name: 'sysWareUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "failure":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{id:params},
                        title: "失效操作",
                        ajaxRequest:HttpFailureSysWarehouse
                    }
                    break;
                case "allfailure":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{ids:params},
                        title: "批量失效操作",
                        ajaxRequest:HttpAllFailureSysWarehouse,
                    }
                    break;
                case "active":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{id:params},
                        title: "生效操作",
                        ajaxRequest:HttpActiveSysWarehouse
                    }
                    break;
                case "allactive":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params},
                        title: "批量生效操作",
                        ajaxRequest:HttpAllActiveSysWarehouse
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        width:460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/WarehouseCarrierService/batchImport",
                        name: "excelFile",
                        component: "compUpload",
                        download:this.downloadExcel
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/WarehouseCarrierService/export',{ids:params},'download');
                    break;
            }
        },
        downloadExcel(){
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/WarehouseCarrierService/warehouseCarrierTemplate", {}, 'download') 
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id, status} = row;
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show:status!=1,
                params:id,
                operate:'edit'
            },{
                label:'失效',
                show:status!=1,
                params:id,
                operate:'failure'
            },
            {
                label:'生效',
                show:status==1,
                params:id,
                operate:'active'
            }]
        },
    },
    computed: {
        ...mapState('boss', ['countries','warehouseList','sysdeliveries','syswarehouses']),
        // table中单据状态的按钮展示
        orderStatus(){
            return [
                {
                    value: '0',
                    label: '有效',
                    theme:'info',
                },
                {
                    value: '1',
                    label: '失效',
                    theme:'error',
                }, 
            ];
        },
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: "批量管理",
                    operate: "batchmanage",
                    theme: "primary",
                    batch:true,
                },
                {
                    name: "批量生效",
                    operate: "allactive",
                    more: true,
                    batch:true
                },
                {
                    name: "批量失效",
                    operate: "allfailure",
                    more: true,
                    batch:true
                },
                {
                    name: "批量导入",
                    operate: "import",
                    more: true,
                    // batch:true
                },
                {
                    name: "批量导出",
                    operate: "export",
                    more: true,
                    batch:true
                }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            const dropStyle="width:auto;min-width:250px;";
            return  [
                {
                    label: "系统发运方式",
                    tag: 'vSelect',
                    key: 'EQ_carrierServiceCode',
                    show:true,
                    options:this.sysdeliveries.map(function(item){
                        // console.log(item)
                        const {carrierServiceCode}=item;
                        return {
                            value: carrierServiceCode,
                            label: carrierServiceCode
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'EQ_warehouseCode',
                    show:true,
                    options:this.syswarehouses.map(function(item){
                        const {id,title,code}=item;
                        return {
                            value: code,
                            label:title+'('+code+')'
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "仓库所在国家",
                    tag: 'vSelect',
                    key: 'country',
                    options:this.countries.map(function(item){
                        // console.log(item)
                        const {code,nameEn} = item;
                        return {
                            value: code ? code : nameEn,
                            label: code + ' (' + nameEn + ')'
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "状态",
                    tag: 'vSelect',
                    key: 'EQ_status',
                    options:[
                        {label:'有效',value:0},
                        {label:'失效',value:1}
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "仓库Shipping Method Code",
                    tag: 'vInput',
                    key: 'EQ_carrierServiceApiCode',
                    formItem:{
                        labelWidth:164,
                    }
                },
                
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: '操作',
                width: 70,
                render:this.getOperateNodes
            }, 
            {
                title: '系统发运方式',
                // key: 'carrierServiceCode',
                render:(h,{row})=>{
                    return <div>
                        <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.carrierServiceCode} ({row.carrierCode} {row.carrierServiceName})</a>
                        <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        
                        </div>
                }
            },
            
            {
                title: '仓库发运方式',
                key: 'carrierServiceApiCode',
            },
            {
                title: '仓库',
                // key: 'warehouseCode',
                render:(h,{row})=>{
                    return <div>{row.warehouseCode}({row.warehouseTitle})</div>
                }
            },
            {
                title: '状态',
                // key: 'status',
                sortable: true,
                maxWidth:80,
                render:(h,{row})=>{
                    const status=row.status;
                    const {theme,label}=this.orderStatus.find(function(item){
                        return item.value==status
                    })||{};
                    return <vButton ghost theme={theme} size="small" class="cursor-default width-60">{label}</vButton>
                    // return <div>{row.status == 0 ? '有效' : '失效'}</div>
                }
            },
            {
                title: '更新时间',
                key: 'updatedAt',
                sortable: true
            }
        ];
        },
        
    },

};
